import styled from "@emotion/styled";
import React from "react";

const Container = styled.div<any>`
  display: ${(props) => (props.inline ? `inline-block` : null)};
`;

const Content = styled.div`
  display: block;
  padding: 4px 0;
  line-height: 24px;

  ::before,
  ::after {
    content: " ";
    display: table;
  }

  ::after {
    clear: both;
  }

  * {
    float: left;
  }
`;

const Control = styled.div`
  min-width: 120px;
  width: calc(100% - 120px);
  position: relative;
  display: flex;
  align-items: center;
`;

const BtnContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export interface IToolbarRadioButtonGroupProps {
  name: string;
  defaultValue?: string;
  options: IToolbarRadioButtonGroupOption[];
  onSelect?: (value: string) => void;
  inline?: boolean;
}

export interface IToolbarRadioButtonGroupOption {
  label?: string;
  icon?: React.ReactNode;
  value: string;
}

export const ToolbarRadioButtonGroup: React.FC<IToolbarRadioButtonGroupProps> =
  ({ name, defaultValue, options, inline, onSelect }) => {
    return (
      <Container inline={inline}>
        <Content>
          <Control>
            <BtnContainer>
              {options.map((option, index) => (
                <ToolbarButton
                  key={index}
                  name={name}
                  value={option.value}
                  icon={option.icon}
                  defaultChecked={option.value == defaultValue}
                  onChange={(value: string) => onSelect?.(value)}
                />
              ))}
            </BtnContainer>
          </Control>
        </Content>
      </Container>
    );
  };

const Label = styled.label`
  position: relative;

  input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    outline: none;

    :checked + .button {
      background: var(--builder-input-background);
    }
  }

  :first-of-type .button {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  :last-of-type .button {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  &:not(:last-child) .button {
    border-right-width: 0;
  }
`;
const BtnSpan = styled.span`
  text-align: center;
  line-height: 1;
  position: relative;
  outline: none;
  font-family: inherit;
  opacity: 0.9;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  text-transform: none;
  border: none;
  min-width: 25px;
  min-height: 25px;
  color: var(--builder-text-color);
  border-radius: 0;
  background: var(--builder-button-option);
  display: flex;
  width: 30px;
  height: 28px;
  padding: 6px;
  border: 1px solid var(--builder-button-dark-border);

  :hover {
    opacity: 1;
  }
`;
const ToolbarButton = ({
  name,
  value,
  icon,
  defaultChecked,
  onChange,
}: any) => {
  return (
    <Label>
      <input
        type="radio"
        name={name}
        defaultChecked={defaultChecked}
        value={value}
        onChange={(e) => {
          onChange?.(e.target.value);
        }}
      />
      <BtnSpan className="button">{icon}</BtnSpan>
    </Label>
  );
};
